// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { i18n } from '../../index'
import { withRouter } from 'react-router-dom'
import { Query } from 'react-apollo'
import { Paper, Typography } from '@mui/material'
import Loader from '../../../common/loader/Loader'
import { get } from 'lodash'
import StationPage from './StationPage'
import EfficiencyFactorTable from './EfficiencyFactorTable'
import type { EfficiencyFactorGroup } from '../../station/stationTypes'
import css from './stationPage.css'
import { fetchEfficiencyFactors, fetchHesburgerEfficiencyBoundary } from '../../station/stationQueries'
import HesburgerEfficiencyBoundaryTable from './HesburgerEfficiencyBoundaryTable'

type StationProfitCenterPageProps = {
  match: {
    params: {
      stationId: string
    }
  }
}

const StationProfitCenterPage = ({ match }: StationProfitCenterPageProps) => (
  <StationPage title={i18n.t('admin.stations.title.profitCentersPage')}>
    <Query<
      {
        data: Array<EfficiencyFactorGroup>
      },
      {
        stationId: string
      }
    >
      query={fetchEfficiencyFactors}
      variables={{
        stationId: match.params.stationId,
      }}
    >
      {({ data, error, loading }) => (
        <Loader
          {...{
            error,
            loading,
          }}
        >
          <div className={css.component}>
            <Typography variant='subtitle2' className={css.subtitle}>
              {i18n.t('admin.stations.title.efficiencyFactors')}
            </Typography>
            <Paper>
              <EfficiencyFactorTable data={data.efficiencyFactors || []} stationId={match.params.stationId} />
            </Paper>
          </div>
        </Loader>
      )}
    </Query>

    <Query
      query={fetchHesburgerEfficiencyBoundary}
      variables={{
        stationId: match.params.stationId,
      }}
    >
      {({ data, error, loading }) => (
        <Loader
          {...{
            error,
            loading,
          }}
        >
          <div className={css.component}>
            <Typography variant='subtitle2' className={css.subtitle}>
              {i18n.t('admin.stations.title.hesburgerEfficiencyFactors')}
            </Typography>

            <Paper>
              <HesburgerEfficiencyBoundaryTable
                data={get(data, 'hesburgerEfficiencyBoundary')}
                stationId={match.params.stationId}
              />
            </Paper>
          </div>
        </Loader>
      )}
    </Query>
  </StationPage>
)

export default withRouter(StationProfitCenterPage)
